module.exports = __webpack_public_path__ + "img/cash_register_4.2e943cfa.jpg";